import createRoute from '@widesk-ui/tools/createRoute';
import OrderModel  from '@models/shop/OrderModel';

export default createRoute.splitView(
	'/entertainments/:entertainmentId/orders-client-pro',
	'shop',
	'OrderClientProSplitView',
	OrderModel.localize('plural') + ' PRO'
);
